import type { IconProps } from '../types/IconProps.ts';
export const Paperclip: IconProps = {
    name: 'Paperclip',
    children: [
        `<path d="M10 6.21v9.58a2 2 0 0 0 4 0V6a4 4 0 0 0-8 0v10a6 6 0 0 0 12 0V6.21" />`,
    ]
};